var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUsers = function SvgUsers(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M16.554 17.75v1.5c0 .45-.301.75-.753.75s-.753-.3-.753-.75v-1.5c0-1.275-.98-2.25-2.26-2.25H6.766c-1.28 0-2.259.975-2.259 2.25v1.5c0 .45-.301.75-.753.75S3 19.7 3 19.25v-1.5C3 15.65 4.657 14 6.765 14h6.024c2.108 0 3.765 1.65 3.765 3.75zm-10.542-9C6.012 6.65 7.669 5 9.777 5s3.765 1.65 3.765 3.75-1.657 3.75-3.765 3.75-3.765-1.65-3.765-3.75zm1.506 0c0 1.275.979 2.25 2.259 2.25 1.28 0 2.259-.975 2.259-2.25s-.979-2.25-2.26-2.25c-1.28 0-2.258.975-2.258 2.25zm10.692 5.4c-.376-.075-.828.15-.903.525-.075.375.15.825.527.9.979.225 1.656 1.125 1.656 2.175v1.5c0 .45.302.75.753.75.452 0 .753-.3.753-.75v-1.5c.076-1.725-1.054-3.225-2.786-3.6zm-3.012-9c-.376-.15-.753.075-.903.525-.075.375.15.825.527.9 1.205.3 1.958 1.5 1.657 2.775A2.303 2.303 0 0 1 14.822 11c-.377.075-.678.525-.527.9.075.375.376.6.753.6h.15c1.356-.375 2.41-1.35 2.711-2.7.527-2.1-.677-4.2-2.71-4.65z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUsers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/users.17a5bf8a39b583c957178cac7e0c2981.svg";